import AxiosServices from './axios-service';
import {endpoints} from './api-end-points';

export class StripeServices {  

  secret(body){    
    const res = AxiosServices.post(endpoints.stripe.secret, body);
    return res;
  }

}
const stripeServices = new StripeServices();
export default stripeServices;
